module.exports = __webpack_public_path__ + "img/motorcycle-icon.d84008e3.svg";